import { genView } from "./colleges";

export default genView("jerseyNumbers");
